// ------------------------------------
// Ação Formulário (Modal)
// ------------------------------------
(function ($) {
  'use strict';

  // Modal
  let $modal;
  // Título do modal
  let $modalTitle;
  // Formulário
  let $modalForm;
  // Botão principal do formulário
  let $modalBtn;
  // Ação a ser executada (insert/update)
  let action;
  // Campo oculto onde é passado a ação 'action'
  let $actionInput;
  // Campo oculto onde é passado a ID do registro que será editado
  let $inputUpdateID;
  // ID do registro que será editado
  let idUpdate;

  // Evento ao clicar no botão para exibir o modal do formulário
  $('[data-form-modal]').on('click', handleModal);

  // Evento de click em uma ação
  function handleModal(ev) {
    ev.preventDefault();
    const $el = $(this);
    $modal = $('#' + $el.data('form-modal'));
    $modalTitle = $modal.find('.modal-title');
    $modalForm = $modal.find('.form-admin');
    $modalBtn = $modalForm.find('.btn-submit');
    $inputUpdateID = $modalForm.find('input[name="id_update"]');
    $actionInput = $modalForm.find('input[name="acao"]');
    action = $el.data('form-action');
    $modalTitle.text($modalTitle.data(action));
    $modalBtn.text($modalBtn.data(action));
    $actionInput.val(action);
    if ($modal.length === 0 || $modalForm.length === 0) {
      console.log('Modal ou formulário não encontrado.');
      return false;
    }
    if (action === 'insert') {
      showModalInsert();
    } else if (action === 'update') {
      idUpdate = $el.data('registro');
      const url = $el.data('url');
      const extraData = $el.data('opts');
      getRegistroModal(url, extraData);
    }
  }

  // Exibe o modal no modo 'Insert'
  function showModalInsert() {
    resetForm();
    $modal.modal('show');
  }

  // Exibe o modal no modo 'Update'
  function showModalUpdate() {
    hideLoader();
    $modal.modal('show');
  }

  // Retorna o formulário ao estado inicial
  function resetForm() {
    resetFormInputs($modalForm);
  }

  // Popula o formulário com os dados do registro a ser editado
  function populaForm(registro) {
    const ignoredFields = ['token', 'acao', 'id_update', 'retorno'];
    for (let row in registro) {
      if (ignoredFields.indexOf(row) !== -1) {
        continue;
      }
      const $input = $modalForm.find(`[name="${row}"]`);
      if ($input.length > 0) {
        // Checkbox e radios
        if ($input.attr('type') == 'checkbox' || $input.attr('type') == 'radio') {
          $input.prop('checked', false);
          $modalForm.find(`[name="${row}"][value="${registro[row]}"]`).prop('checked', true);
          if ($input.attr('type') == 'radio') {
            $modalForm.find(`[name="${row}"][value="${registro[row]}"]`).click();
          }
        }
        // Password
        else if ($input.attr('type') == 'password') {
          $input.prop('required', false);
        }
        // Campos padrões
        else {
          $input.val(registro[row]);
        }
        // Adiciona o id nos parâmetros do validador remoto
        if ($input[0].hasAttribute('data-parsley-remote-validator')) {
          $input.parsley().on('field:ajaxoptions', function (instance, ajaxOptions) {
            ajaxOptions.data.id = idUpdate;
          });
        }
        $input.trigger('change');
      }
      // Checkbox e radios (Arrays)
      if ($.isArray(registro[row])) {
        const list = registro[row];
        $.each(list, function (item) {
          const $input = $modalForm.find(`[name^="${row}["][value="${list[item]}"]`);
          if ($input.length > 0) {
            $input.prop('checked', true);
          }
        });
      }
    }
    $modalForm.find('input[type="password"]').prop('required', false);
    $inputUpdateID.val(idUpdate);
    showModalUpdate();
  }

  // Obtém os dados de um registro
  function getRegistroModal(url, extraData) {
    showLoader();
    extraData = extraData ? extraData : {};
    $.getJSON(`${url}update?id_update=${idUpdate}`, extraData, function (resp) {
      console.log(resp);
      if (resp.status == 'success') {
        // Popula o formulário
        resetForm();
        populaForm(resp.registro);
      } else {
        hideLoader();
        Toast.fire({
          type: 'error',
          title: resp.mensagem,
        });
      }
    }).fail(function (resp) {
      console.log(resp);
      hideLoader();
      Toast.fire({
        type: 'error',
        title: 'Não foi possível carregar os dados do registro.',
      });
    });
  }
})(jQuery);
